import React from 'react'
import './App.css'
import { BrowserRouter } from 'react-router-dom'
import MainContainer  from '../views/main/container/MainContainer'
import { ToastComponent } from '../components'
import { NotificationProvider } from '../components/Toast/NotificationProvider'

const App = (): JSX.Element => {
  return (
    <NotificationProvider>
      <BrowserRouter>
        <MainContainer />
        <ToastComponent />
      </BrowserRouter>
    </NotificationProvider>
  )
}

export default App
